module.exports = __webpack_public_path__ + "media/images/front/robles_factory-7929ab4fb6c3dce430e37d8d37a1c330.jpg";